import DoDisturbIcon from "@mui/icons-material/DoDisturb"
import {
    Box,
    Dialog,
    Stack,
    Theme,
    Typography,
    useMediaQuery,
} from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { BASE_URL } from "../../router/routes"
import { RootFrame } from "../../webpageFrame/contentFrames"
import AppButton from "../buttons/appButton"

/**
 * Fallback UI for when user tries to access page for which they do not have
 * access.
 */
const NotAuthorised = (): ReactElement => {
    const isMob = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
    const navigate = useNavigate()
    return (
        <Dialog fullScreen open>
            <RootFrame>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    height="70%"
                >
                    <Stack
                        spacing={5}
                        alignItems="center"
                        width={isMob ? "90%" : "50%"}
                    >
                        <DoDisturbIcon sx={{ fontSize: "200px" }} />
                        <Typography
                            color="primary"
                            variant="h2"
                            fontWeight="500"
                            align="center"
                        >
                            Access Denied
                        </Typography>
                        <Typography
                            variant="h4"
                            align="center"
                            fontWeight="300"
                        >
                            You do not have the correct permissions to view this
                            webpage. If you believe this is an error,{" "}
                            <strong>please contact your administrator </strong>{" "}
                            to get help
                        </Typography>
                        <AppButton
                            variant="contained"
                            onClick={() => navigate(BASE_URL)}
                            sx={{
                                height: "60px",
                                borderRadius: 10,
                                fontSize: "20px",
                                padding: 4,
                            }}
                        >
                            Return to Homepage
                        </AppButton>
                    </Stack>
                </Box>
            </RootFrame>
        </Dialog>
    )
}

export default NotAuthorised
